export default __webpack_public_path__ + "static/media/screenBlock21.9c9625d2.jpg";